import { isEqual } from 'lodash-es';

export const objectsEqual = <T>(object: T, object2: T) => {
  return isEqual({ ...object }, { ...object2 });
};
